import {createStore, applyMiddleware} from 'redux';
import Thunk from 'redux-thunk';
import Reducers from '../reducers';

const store = createStore(Reducers, applyMiddleware(Thunk));
export const dispatch = store.dispatch;
export const getState = store.getState;

export default store;